module.exports = __webpack_public_path__ + "static/media/twitter.64c341fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter.svg
// module id = 901
// module chunks = 1